<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="clientId">
    <label for="clientId">{{ 'Settings::AloTechIntegrationClientId' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="clientId"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="tenantName">
    <label for="tenantName">{{ 'Settings::AloTechIntegrationTenantName' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="tenantName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">{{ 'Settings::AloTechIntegrationSourceName' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="migrationStartDate">
    <label for="migrationStartDate">{{ 'Settings::AloTechIntegrationMigrationStartDate' | abpLocalization }}</label>
    <input
      type="text"
      placeholder="2023-01-31"
      class="form-control form-control-sm"
      id="migrationStartDate"
      formControlName="value" />
  </div>
<div>

  <div class="d-flex align-items-center gap-3 pt-2">

    <div class="form-group mb-0 d-flex align-items-center" formGroupName="assignDefaultDepartment">
      <input
        type="checkbox"
        id="assignDefaultDepartment"
        class="form-check-input me-2" 
        [(ngModel)]="assignDefaultDepartmentCb"
        (change)="onAssignDefaultDepartmentChange($event.currentTarget.checked)"
        formControlName="value"/>
      <label class="form-check-label" for="assignDefaultDepartment">
        {{ 'Settings::AloTechIntegrationAssignDefaultDepartment' | abpLocalization }}
      </label>
    </div>

    <div
      class="form-group mb-0 d-flex align-items-center gap-2"
      *ngIf="form.get('assignDefaultDepartment').value"
      formGroupName="selectedDefaultDepartment">
      
      <label for="selectedDefaultDepartment" class="text-nowrap">
        {{ 'Settings::AloTechIntegrationSelectedDefaultDepartment' | abpLocalization }}:
      </label>

      <ca-select formControlName="value" [options]="{ width: '200px' }">
        <ca-option *ngFor="let dept of departmentList" [value]="dept.id">
          {{ dept.displayName }}
        </ca-option>
      </ca-select>
    </div>
  
  </div> <div class="form-text text-muted mt-1 ps-1">
    {{ 'Settings::AloTechIntegrationAssignDefaultDepartmentDescription' | abpLocalization }}
  </div>

</div>

  <div class="form-group pt-2" formGroupName="defaultLanguageCode">
    <label for="defaultLanguageCode">{{ 'Settings::AloTechIntegrationDefaultLanguageCode' | abpLocalization }}</label>
    <input
      type="text"
      placeholder="en-US"
      class="form-control form-control-sm"
      id="defaultLanguageCode"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="languageCodeTags">
    <label for="languageCodeTags">{{ 'Settings::AloTechIntegrationLanguageCodeTags' | abpLocalization }}</label>
    <input
      type="text"
      placeholder='{"turkish":"tr-TR", "english":"en-US"}'
      class="form-control form-control-sm"
      id="languageCodeTags"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="importIvrCalls">
    <input
      type="checkbox"
      id="importIvrCalls"
      [(ngModel)]="importIvrCallsCb"
      formControlName="value"/>
      <label class="ps-1" for="importIvrCalls">
      {{ 'Settings::AloTechIntegrationImportIvrCalls' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="useQueueFilter">
    <input
      type="checkbox"
      id="useQueueFilter"
      (change)="onUseQueueFilterChange($event.currentTarget.checked)"
      [(ngModel)]="useQueueFilterCb"
      formControlName="value"/>
      <label class="ps-1" for="useQueueFilter">
      {{ 'Settings::AloTechIntegrationUseQueueFilter' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="queueFilterDictionary" *ngIf = "form.get('useQueueFilter.value').value">
    <label for="queueFilterDictionary">{{ 'Settings::AloTechIntegrationQueueFilterDictionary' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="queueFilterDictionary"
      placeholder='{"Queue1Key":"languageCode","Queue2Key":"languageCode"}'
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="useAgentFilter">
    <input
      type="checkbox"
      id="useAgentFilter"
      (change)="onUseAgentFilterChange($event.currentTarget.checked)"
      [(ngModel)]="useAgentFilterCb"
      formControlName="value"/>
      <label class="ps-1" for="useAgentFilter">
      {{ 'Settings::AloTechIntegrationUseAgentFilter' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="agentFilterDictionary" *ngIf = "form.get('useAgentFilter.value').value">
    <label for="agentFilterDictionary">{{ 'Settings::AloTechIntegrationAgentFilterDictionary' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="agentFilterDictionary"
      placeholder='Agent1Key, Agent2Name, Agent3Key'
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="useCustomFieldFilter">
    <input
      type="checkbox"
      id="useCustomFieldFilter"
      (change)="onUseCustomFieldFilterChange($event.currentTarget.checked)"
      [(ngModel)]="useCustomFieldFilterCb"
      formControlName="value"/>
      <label class="ps-1" for="useCustomFieldFilter">
      {{ 'Settings::AloTechIntegrationUseCustomFieldFilter' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="customFieldFilterDictionary" *ngIf = "form.get('useCustomFieldFilter.value').value">
    <label for="customFieldFilterDictionary">{{ 'Settings::AloTechIntegrationCustomFieldFilterDictionary' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="customFieldFilterDictionary"
      placeholder='[{"Level1":"value1","Level2":"value2"}, {"Level1":"value1","Level2":"value2"}]'
      formControlName="value" />
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>{{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
